import { styled } from '@mui/material';
import { DataGridPro, gridClasses } from '@mui/x-data-grid-pro';

import { intakeDataGridCustomClasses } from './IntakeDataGrid.util';

export const DataGridProStyled = styled(DataGridPro)(({ theme }) => {
  return {
    [`&.${gridClasses.root}`]: {
      borderWidth: 0,
    },
    [`& .${gridClasses.columnHeaderTitle}, & .${gridClasses.columnHeaderTitleContainer}`]: {
      ...theme.typography.subtitle2,
    },
    [`& .${gridClasses.columnHeader}:focus-within, & .${gridClasses.cell}:focus-within`]: {
      outline: 'none',
    },
    [`& .${gridClasses.columnHeader}:focus, & .${gridClasses.cell}:focus`]: {
      outline: 'none',
    },
    [`& .${gridClasses.row}`]: {
      cursor: 'pointer',
    },
    [`&.${intakeDataGridCustomClasses.error}`]: {
      backgroundColor: 'rgba(250, 238, 239, 1)',
    },
    [`& .${gridClasses.row}.${intakeDataGridCustomClasses.rowError}`]: {
      [`&.${gridClasses.row}:hover,
        &.Mui-selected .${gridClasses.cell},
        &.Mui-selected:hover .${gridClasses.cell}`]: {
        backgroundColor: 'rgb(249, 209, 212)',
      },
      backgroundColor: 'rgba(250, 238, 239, 1)',
    },
    [`& .${gridClasses.cell}`]: {
      paddingTop: '8px',
      paddingBottom: '8px',
    },
  };
}) as typeof DataGridPro;
